import { createElement } from 'react'
import RsIcon from '../components/icons/RsIcon'

/** CMS / API icon keys → RotationStreet icon names */
export const CMS_ICONS = {
  barChart: 'barChart',
  mail: 'mail',
  clock: 'clock',
  globe: 'globe',
  alertTriangle: 'alertTriangle',
  plus: 'plus',
  shield: 'shield',
  zap: 'zap',
  users: 'users',
  fileText: 'fileText',
  messageSquare: 'messageSquare',
  video: 'video',
  briefcase: 'briefcase',
}

export const ROLE_COLOR_CLASSES = {
  blue: { bg: 'bg-blue-50', text: 'text-blue-600' },
  gold: { bg: 'bg-yellow-50', text: 'text-yellow-600' },
  green: { bg: 'bg-green-50', text: 'text-green-600' },
  purple: { bg: 'bg-purple-50', text: 'text-purple-600' },
}

/** Returns a React component for CMS-driven icons */
export function getCmsIcon(key) {
  const name = CMS_ICONS[key] || key || 'mail'
  return function CmsIcon({ size = 'md', className = '', ...props }) {
    return createElement(RsIcon, { name, size, className, ...props })
  }
}

export function getCmsIconName(key) {
  return CMS_ICONS[key] || key || 'mail'
}
